import { Paper, Table, TableBody, TableContainer, TableHead, TableRow, TableCell, Grid } from '@material-ui/core';
import styles from './style.module.scss';
import { marginListColumns } from './constants';
import { ProductLoader } from '../../components/Loader/skeletonLoader';

const MarginTable = ({ marginUploadData, reqObj, totalPageCount, handlePageChange, loader }) => {
  function formatDate(value) {
    const date = new Date(value);
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(date);
    return formattedDate;
  }

  return (
    <>
      {
        loader ?
          <Paper className={styles.loaderWrapper} >
            <div id={styles.headerLoader}>
            </div>
            <div className="pl-4 pr-4">
              <ProductLoader />
            </div>
          </Paper > :
          <Paper>
            <TableContainer className={styles?.parentWrapper}>
              <Table stickyHeader aria-label="sticky table" >
                <TableHead>
                  <TableRow>
                    {marginListColumns?.map((column, index) => (
                      <TableCell
                        className={styles?.tableBorder}
                        key={index}
                        align={column?.align}
                        style={{ minWidth: column?.minWidth }}
                      >
                        {column?.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {marginUploadData && marginUploadData?.map((marginData) => (
                    <TableRow>
                      {
                        marginListColumns?.map((header) => {
                          const value = marginData[header?.key]
                          if (header?.key !== 'marginType' && header?.key !== 'status') {
                            return <TableCell>{formatDate(value)}</TableCell>
                          }
                          return (
                            <TableCell>{value}</TableCell>
                          )
                        })
                      }
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

            </TableContainer>
            <div className="pl-3 pr-3 p-2">
              <Grid container justify='space-between' >
                <Grid item>
                  <div className="text-muted">
                    Showing {reqObj.page === 1 ? reqObj.page : reqObj.size * (reqObj.page - 1)} -
                    {reqObj.page === 1 ? reqObj.size : (marginUploadData && marginUploadData.length) === reqObj.size ? reqObj.size * reqObj.page : ((reqObj.size * reqObj.page) - (reqObj.size - marginUploadData.length))} of {marginUploadData.length} entries
                    <span className={styles.divider}></span>
                  </div>
                </Grid>
                <Grid item alignItems='center'>
                  <div className="">
                    <nav aria-label="..." style={{ top: 10 }}>
                      <ul className="pagination mb-0">
                        <li onClick={() => reqObj.page > 1 && totalPageCount != 0 ? handlePageChange('prev') : null} className={`page-item ${reqObj.page === 1 || totalPageCount === 0 ? "disabled" : null} `}>
                          <button className={`${reqObj.page === 1 || totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} tabIndex="-1">
                            Previous
                          </button>
                        </li>
                        <li>
                          <button className={`page-link ${styles.page}`} style={{ pointerEvents: 'none' }}>
                            {reqObj.page}
                          </button>
                        </li>
                        <li onClick={() => totalPageCount !== reqObj.page && totalPageCount !== 0 ? handlePageChange('Next') : ''} className={`page-item ${totalPageCount == reqObj.page || totalPageCount === 0 ? "disabled" : null} `}>
                          <button className={`${totalPageCount === reqObj.page || totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Paper>
      }
    </>
  )
}

export default MarginTable;